import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';

import { updateCargoOrder } from 'actions/cargoes/orders';
import helpers from 'helpers';

class TotalValuesVolWei extends React.Component {
    constructor(props) {
        super(props);

        this.onToggleFreeze = this.onToggleFreeze.bind(this);
        this.onChangeQuantity = this.onChangeQuantity.bind(this);
    }

    onToggleFreeze() {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        const { totalValues } = newCargoOrder;
        newCargoOrder.totalValues.isCalc = !totalValues.isCalc;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeQuantity(e, type) {
        const value = parseInt(helpers.clearLetters(e.target.value));
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        
        newCargoOrder.totalValues = {
            ...newCargoOrder.totalValues,
            [type]: ['weight', 'weightWithPercent'].includes(type) ? value * 1000 : value,
        };
        
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    render() {
        const {
            isCalc, weight, weightWithPercent, volume, volumeWithPercent, 
        } = this.props.cargoOrder.totalValues;

        return (
            <div>
                <div className="row">
                    <div className='column-left' style={{ fontSize: '13px' }}>
                        Total Values (weight/volume):
                    </div>
                </div>
                <div className='row'>
                    <div className='one-third'>
                        <Toggle 
                            label="Freeze"
                            style={{ width: '50%', fontSize: '14px' }}
                            toggled={!isCalc || false}
                            onToggle={() => this.onToggleFreeze()}
                        />
                    </div>
                    <div className='one-third'>
                        <TextField
                            value={weight && weight / 1000 || ''}
                            style={{ width: '50%', fontSize: '14px' }}
                            floatingLabelText='Weight, mt'
                            onChange={(e) => { this.onChangeQuantity(e, 'weight'); }}
                        />
                    </div>
                    <div className='one-third'>
                        <TextField
                            value={weightWithPercent && weightWithPercent / 1000 || ''}
                            style={{ width: '50%', fontSize: '14px' }}
                            floatingLabelText='Weight+%, mt'
                            onChange={(e) => { this.onChangeQuantity(e, 'weightWithPercent'); }}
                        />
                    </div>
                    <div className='one-third' />
                    <div className='one-third'>
                        <TextField
                            value={volume || ''}
                            style={{ width: '50%', fontSize: '14px' }}
                            floatingLabelText='Volume, m3'
                            onChange={(e) => { this.onChangeQuantity(e, 'volume'); }}
                        />
                    </div>
                    <div className='one-third'>
                        <TextField
                            value={volumeWithPercent || ''}
                            style={{ width: '50%', fontSize: '14px' }}
                            floatingLabelText='Volume+%, m3'
                            onChange={(e) => { this.onChangeQuantity(e, 'volumeWithPercent'); }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(TotalValuesVolWei);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/TotalValuesVolWei.jsx